function removePersistedSessionKeys(): void {
  const keysToRemove = Object.keys(sessionStorage).filter(
    key => key.startsWith('arago-') || key.startsWith('pinia-')
  )

  keysToRemove.forEach(key => sessionStorage.removeItem(key))
}

export async function resetBusinessStores(): Promise<void> {
  const [
    { useArchivesStore },
    { useLoadingStore },
    { usePerimeterStore },
    { useRootStore },
    { useSimulationStore },
    { useSolvencyStore },
    { useTransparisationStore },
  ] = await Promise.all([
    import('@/stores/archives'),
    import('@/stores/loading'),
    import('@/stores/perimeter'),
    import('@/stores/root'),
    import('@/stores/simulation'),
    import('@/stores/solvency'),
    import('@/stores/transparisation'),
  ])

  useArchivesStore().reset()
  useLoadingStore().resetLoading()
  useLoadingStore().clearAppError()
  usePerimeterStore().reset()
  useRootStore().reset()
  useSimulationStore().reset()
  useSolvencyStore().reset()
  useTransparisationStore().reset()

  removePersistedSessionKeys()
}